import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/dialpad-star-reversed.vue
var s = {
	name: "DtIconDialpadStarReversed",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--dialpad-star-reversed"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Dialpad Star Reversed",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M1.8 0A1.8 1.8 0 0 0 0 1.8v8.4A1.8 1.8 0 0 0 1.8 12h8.4a1.8 1.8 0 0 0 1.8-1.8V1.8A1.8 1.8 0 0 0 10.2 0H1.8Zm4.577 3.58c.067.016.08.125.017.154-1.22.411-2.179 1.465-2.68 2.866-.028.068-.148.052-.16-.02-.17-1.1-.936-1.978-1.922-2.215-.066-.015-.078-.117-.017-.146 1.252-.511 2.193-1.56 2.628-2.9.027-.07.158-.052.17.022.168 1.122.954 2.016 1.964 2.24ZM5.349 7.902c0 1.415.927 2.45 2.219 2.45.6 0 1.173-.31 1.427-.7v.608h1.055V3.63H8.995v2.522c-.254-.39-.827-.69-1.427-.69-1.292 0-2.22 1.025-2.22 2.44Zm3.646.29c-.063.717-.573 1.243-1.255 1.243-.764 0-1.31-.635-1.31-1.542s.546-1.515 1.31-1.515c.682 0 1.192.5 1.255 1.216v.598Z",
		fill: "currentColor"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=dialpad-star-reversed.js.map